<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('bulletin.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'bulletins' }">{{ $t('bulletin.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row">
        <div class="col">
          <b-list-group>
            <b-list-group-item
              class="flex-column align-items-start"
              :to="{ name: 'course-cancel-bulletin' }"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ $t('course-cancel-bulletin.title') }}</h5>
              </div>
            </b-list-group-item>
            <b-list-group-item
              class="flex-column align-items-start"
              v-for="bulletin in bulletins"
              :key="bulletin.id"
              href="javascript:void(0)"
              @click="showBulletinInfo(bulletin)"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ bulletin.title }}</h5>
                <small>{{ bulletin.publish_start_date }}</small>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
    <info-modal id="bulletin-info" :title="$t('bulletin.title')">
      <template #info>
        <bulletin-info :bulletin="bulletin"></bulletin-info>
      </template>
    </info-modal>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'

import BulletinInfo from '@/components/info/BulletinInfo'
import InfoModal from '@/components/modals/InfoModal.vue'

import i18n from '@/plugins/i18n.js'

import BulletinApiService from '@/services/budaedu-api-services/bulletin-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(OverlayPlugin)

Vue.use(BulletinApiService)

export default {
  i18n,
  name: 'bulletins',
  data() {
    return {
      is_loading: false,
      bulletins: [],
      bulletin: null
    }
  },
  methods: {
    showBulletinInfo(bulletin) {
      this.bulletin = bulletin
      this.$bvModal.show('bulletin-info')
    },
    async setBulletins() {
      this.is_loading = true
      this.bulletins = []
      try {
        let items = await this.$bulletinApiService.getPublishing(
          'include=attachments&order=publish_start_date,desc|updated_at,desc'
        )
        this.bulletins = items.data
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`)
    await this.setBulletins()
  },
  components: {
    BulletinInfo,
    InfoModal
  },
  metaInfo() {
    return {
      title: this.$t('bulletin.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>